export enum PartBomDetailsTab {
  ITEM_LIST = 'itemList',
  PART_DETAILS = 'partDetails',
}
